module.exports = __webpack_public_path__ + "static/media/movie-app.9305b0da.PNG";